import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("img", {
    src: $options.url,
    onLoad: _cache[0] || (_cache[0] = (...args) => ($options.onLoad && $options.onLoad(...args)))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}